import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,hasClass,on,findIn, findAllIn} from '@elements/dom-utils';
import {translate} from '@elements/translations';

const selectors = {
    base: '.js-accordion',
    btn: '.js-accordion__toggle-all',
    text: '.js-accordion__toggle-text'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let btn = findIn(selectors.btn, baseElement);
        let text = findIn(selectors.text, btn);

        on("click", function () {
            if (hasClass('open', btn)) {
                removeClass('open', btn);

                if(hasClass('is-system', text)){
                    text.innerHTML = translate('system.accordion.open-all');
                } else {
                    text.innerHTML = translate('accordion.open-all');
                }

                findAllIn('.accordion-item', baseElement).forEach((item) => {
                    removeClass('show', findIn('.collapse', item));
                    addClass('collapsed', findIn('.accordion-button', item));
                });
            }else{
                findAllIn('.accordion-item', baseElement).forEach((item) => {
                    addClass('show', findIn('.collapse', item));
                    removeClass('collapsed', findIn('.accordion-button', item));
                });

                addClass('open', btn);

                if(hasClass('is-system', text)){
                    text.innerHTML = translate('system.accordion.close-all');
                } else {
                    text.innerHTML = translate('accordion.close-all');
                }
            }
        }, btn);
    });
}
